"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.portrait = exports.root = void 0;

const root = () => ({
  height: 224,
  overflow: 'hidden',
  width: '100%'
});

exports.root = root;

const portrait = () => ({
  alignSelf: 'flex-end',
  marginRight: -8
});

exports.portrait = portrait;
//# sourceMappingURL=PageCover.style.js.map